module.exports = __webpack_public_path__ + "static/herbal-house-c6d222d5189fed4d0528199b25729aea.png";